import * as React from 'react'
import cc from 'classcat'
import Button from '../Button'

import s from './styles.module.css'

export default class CardWithButton extends React.Component {
  render() {
    const {
      title,
      content,
      buttonContent,
      className,
      titleClassName,
      buttonClassName
    } = this.props

    return (
      <div className={cc([s.card, className])}>
        <h3 className={cc([s.title, titleClassName])}>{title}</h3>
        {content}
        <Button anchor="contact-form" className={cc([s.button, buttonClassName])}>
          {buttonContent}
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CardWithButton/index.js